<mat-form-field appearance="outline" class="folder-tree-field">
	<mat-label>{{'add-collection-folder_destination-folder' | translate }}</mat-label>
	<mat-select
		#folderSelect
		data-cy="folder-selection"
		[(ngModel)]="selectedFolder"
		[panelClass]="'folder-tree-select-panel data-cy-folder-panel'"
		(openedChange)="onSelectOpenedChange($event)"
		(selectionChange)="onFolderSelected($event)">

		@if (showNoneOption) {
			<mat-option [value]="null" class="root-option">
				<div class="folder-option">
					<span class="expand-spacer"></span>
					<span>{{ 'common_none' | translate }}</span>
				</div>
			</mat-option>
			<mat-divider></mat-divider>
		}

		<!-- You must render ALL folders in order for mat-select to register them. Hide unexpanded options with CSS -->
		@for (folder of displayFolders; track folder.id) {
			<mat-option
				[value]="folder"
				[ngClass]="getFolderOptionClass(folder)"
				[style.padding-left.px]="16 + (folder.level * 24)">
				<div class="folder-option">
					@if (folder.hasChildren) {
						<button
							mat-icon-button
							class="expand-button"
							(click)="toggleFolderExpansion(folder, $event)"
							type="button"
							[attr.aria-label]="
								(folder.isExpanded
								  ? ('folder_tree_select-collapse' | translate:{ name: folder.name })
								  : ('folder_tree_select-expand' | translate:{ name: folder.name })
								)
						    "
							[attr.aria-expanded]="folder.isExpanded">
							@if (folder.isExpanded) {
								<mat-icon matIconSuffix class="ficon-app-chevron-down"></mat-icon>
							} @else {
								<mat-icon matIconSuffix class="ficon-app-chevron-right"></mat-icon>
							}
						</button>
					} @else {
						<span class="expand-spacer"></span>
					}
					<span class="folder-name">{{ folder.name }}</span>
				</div>
			</mat-option>
		}
	</mat-select>
	<mat-icon matIconSuffix class="ficon-app-chevron-down"></mat-icon>
</mat-form-field>
